<template>
  <v-dialog v-model="dialog" fullscreen style="z-index: 9999999;">
    <v-card>

      <div class="text-right" style="margin-top:64px">


        <v-spacer></v-spacer>
        <v-btn icon large @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-layout row>
        <v-flex xs12 sm8>
          <v-col class="pa-4 pt-0">

            <div id="videoContainer" ref="playerContainer" class="video-container" style="border-radius:10px"></div>
            <h2 class="mt-5">
              {{ playerName }}
            </h2>
          </v-col>
        </v-flex>

        <v-flex xs12 sm4>
          <v-card class="ma-4 mt-0 ml-2" style="border-radius:10px;border:1px solid #ddd" elevation="0">
            <h2 class="pa-5">플레이리스트 명</h2>

            <v-list-item-group v-model="currentVideoIndex" color="gray">
              <v-list-item v-for="(video, index) in videos" :key="video.title" @click="selectVideo(index)" two-line
                class="pa-2" :class="{ 'selected': index === currentVideoIndex }">
                <div class="list_layout" style="display:flex; justify-content: space-between;">

                  <section style="display: flex; flex-direction: column; justify-content: center;">
                    <div class="image-container ma-1">
                      <img :src="video.image"
                        style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;"
                        :contain="true" />
                    </div>
                  </section>
                  <section class="pa-2" style="display: flex; flex-direction: column; justify-content: center;">
                    <div style="word-break:break-all;">
                      {{ video.title }}
                    </div>
                    <div style="color:#aaa">
                      {{ video.runtime }}
                    </div>
                  </section>
                </div>
              </v-list-item>
            </v-list-item-group>

          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import PlaylistApi from "@/api/playlist/PlaylistApi";
import OvenPlayer from 'ovenplayer';
import Hls from 'hls.js';

export default {
  props: ['value'],
  data() {
    return {
      dialog: this.value,
      videos: [],
      currentPlaylistName: 'Playlist Name',
      playerInstance: null,
      currentVideoIndex: 0,
      playerName: '',
      isVideoPlaying: false
    };
  },
  methods: {
    setGroupId(url) {
      console.log('url', url);
      this.url = url;
    },
    closeModal() {
      this.dialog = false;
      this.videos = [];
      this.currentVideoIndex = 0;
      this.selectedVideoURL = '';
      this.playerName = '';
      this.isVideoPlaying = false;
      this.$emit('input', this.dialog);
      if (this.playerInstance) {
        // console.log('닫기');
        this.playerInstance.remove();
        this.playerInstance = null;
      }
    },
    async modalList(url) {
      if (!this.videos.length) {
        try {
          const response = await PlaylistApi.modalplaylist(url);
          if (response && Array.isArray(response.tracks)) {
            // console.log('res', response);
            this.videos = response.tracks.map(track => ({
              image: track.posterImg ? track.posterImg : "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png",
              runtime: track.runtime,
              title: track.name,
              smil_player_url: track.smil_player_url.trim(),
              sources: [{
                type: 'hls',
                file: track.smil_player_url.trim()
              }]
            }));
            this.initPlayer();
          } else {
            // console.error('api호출 에러', response);
          }
        } catch (error) {
          console.error('Error', error);
        }
      }
    },
    initPlayer() {
      this.playerInstance = OvenPlayer.create('videoContainer', {
        //playlist: this.videos
        playlist: this.videos.map(video => ({
          title: video.title,
          image: video.image, 
          sources: video.sources,
          tracks: video.tracks
        })),
        showBigPlayButton: true,

      });

      this.playerInstance.on('playlistChanged', (index) => {
        this.currentVideoIndex = index;
        this.playerName = this.videos[index].title;

        this.closePlaylist();

        this.isVideoPlaying = false;
        setTimeout(() => {
          this.playerInstance.play();
        }, 300);
      });

      this.playerInstance.on('ready', () => {
        this.playerInstance.play();
      });

      this.playerInstance.on('play', () => {
        this.isVideoPlaying = true;
      });

      this.playerInstance.on('complete', () => {
        if (this.isVideoPlaying) {
          //console.log('비디오준비 현재순서', this.currentVideoIndex);
          if (this.currentVideoIndex < this.videos.length - 1) {
            //console.log('다음으로 이동', this.currentVideoIndex + 1);
            this.currentVideoIndex += 1;
            setTimeout(() => {
              this.selectVideo(this.currentVideoIndex);
            }, 500);
          } else {
            // console.log('Playlist complete');
          }
        }
      });
    },
    closePlaylist() {
      const playlistButton = document.querySelector('.op-close-icon.btn-close');
      if (playlistButton) {
        playlistButton.click();
      } else {
        //console.log('버튼을 찾을 수 없습니다.');
      }
    },
    selectVideo(index) {
      //console.log('비디오 선택', index);
      if (this.playerInstance) {
        this.currentVideoIndex = index;
        this.isVideoPlaying = false;
        this.playerInstance.setCurrentPlaylist(index);
        setTimeout(() => {
          this.playerInstance.play();
        }, 300);
        this.playerName = this.videos[index].title;
        //console.log('비디오선택한거 재생', this.videos[index]);
      }
    }
  },
  beforeDestroy() {
    if (this.playerInstance) {
      //console.log('비디오설정 삭제');
      this.playerInstance.remove();
      this.playerInstance = null;
    }
  },
  watch: {
    value(newVal) {
      this.dialog = newVal;
      if (newVal) {
        if (this.url) {
          this.modalList(this.url);
        }

        this.currentVideoIndex = 0;

        if (this.playerInstance) {
          setTimeout(() => {
            this.playerInstance.setCurrentPlaylist(0);
            this.playerInstance.play();
          }, 300);
        }
      }
    },
    dialog(newVal) {
      this.$emit('input', newVal);
      if (newVal) {
        if (this.url) {
          // this.modalList(this.url);
        }
      } else {
        this.closeModal();
      }
    }
  }
};
</script>
<style scoped>
.selected {
  background-color: #f0f0f0;
}

.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.button-icon {
  background-image: url('@/styles/assets/onerepeat_icon.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 24px;
  height: 24px;
  border: none;
  cursor: pointer;
}

.image-container {
  position: relative;
  background-color: black;
  width: 107px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>
